import { BulkDataIcon } from '@hcs/design-system';
import { AppSlugs } from '@hcs/types';
import { AppConfig } from '@hcs/types';

export const APP_CONFIG_BULK_DATA: AppConfig = {
  name: 'Bulk Data',
  applicationKey: 'internal-bulk-data',
  type: 'internal',
  appSlugForEngagement: AppSlugs.BulkData,
  rootPath: '/bulk-data',
  Icon: BulkDataIcon,
  descriptionLong: 'Manage Bulk Data Jobs and Deliveries',
  descriptionShort: 'Manage Bulk Data Jobs and Deliveries',
};

export const VIEW_PATHS_BULK_DATA = {
  SALES_JOB: 'sales-job',
  OWNERSHIP_JOB: 'ownership-job',
} as const;
